import {User} from '@hconnect/apiclient'
import {TimeZone} from '@hconnect/common/types'
import {COMMENTS_DATE_FORMAT, formatTimeZoneDate} from '@hconnect/uikit'

import type {CommentDto} from '../api'
import {CommentStatus} from '../api'
import {EnhancedComment} from '../types'

export const mapCommentDtoToEnhancedComment = (
  dto: CommentDto,
  timezone: TimeZone,
  language: string,
  currentUserName: User['name']
): EnhancedComment => {
  const isEdited = dto.status === CommentStatus.Edited
  const name = isEdited ? dto.updatedBy : dto.createdBy
  const date = isEdited ? dto.updatedOn : dto.createdOn

  return {
    id: dto.commentId,
    date: formatTimeZoneDate(date, timezone, COMMENTS_DATE_FORMAT, language),
    name,
    content: dto.value,
    isEditable: name === currentUserName,
    isDeletable: name === currentUserName,
    commentsCategoryInstanceId: dto.commentsCategoryInstanceId
  }
}
